import { AxiosGet } from "../useApi";

export function GetQueues(instanceId) {
    const route = 'queues';
    return AxiosGet(route, { instanceId });
}

export function GetQueue(instanceId, queueId) {
    const route = 'queue';
    return AxiosGet(route, { instanceId, queueId });
}

export function GetQueueStatuses(params) {
    const route = 'queue-statuses';
    return AxiosGet(route, params);
}

export function GetQueueStatus(instanceId, queueId) {
    const route = 'queue-status';
    return AxiosGet(route, { instanceId, queueId });
}